import { apiClient } from "../apiClient";
import { BACKEND_ENDPOINTS, RAG_CONTRACT_ENDPOINTS } from "../apiEndpoints";

export const contractUploadApi = (file) => {
  const formData = new FormData();
  formData.append("file", file);
  return apiClient.post(
    `${BACKEND_ENDPOINTS.AI_API_BASE_URL}${RAG_CONTRACT_ENDPOINTS.CONTRACT_UPLOAD}`,
    formData,
    { headers: { "Content-Type": "multipart/form-data" } }
  );
};

export const contractRunAnalysisApi = (endpoint, document) =>
  apiClient.post(
    `${BACKEND_ENDPOINTS.AI_API_BASE_URL}${endpoint}`,
    JSON.stringify({ document }),
    { headers: { "Content-Type": "application/json" } }
  );
